<template>
  <DialogTemplate
    :contentStretch="true"
    style="max-width: unset"
    :contentStyle="'margin:0!important;padding:0!important;'"
  >
    <div
      class="yt-video"
      data-tst="yt_video"
    >
      <div
        ref="cont"
        class="yt-video_container"
        @click.stop
      >
        <GwVideoPlayer
          autoplay
          style="width: 100%; height: 100%"
          type="youtube"
          :src="videoId"
        />
      </div>
    </div>
  </DialogTemplate>
</template>

<script>
import DialogTemplate from '@/components/Dialogs/DialogTemplate'
import GwVideoPlayer from '@/components/lib/GwVideoPlayer'

export default {
  name: 'YtDialog',
  components: {
    GwVideoPlayer,
    DialogTemplate,
  },
  props: {
    dialog: Object,
  },
  data() {
    return {
      videoId: '2F0oPG1PGQA',
    }
  },
  created() {
    if (this.dialog.play) {
      const list = {
        // vids are most likely outdated content vise
        rangeBuilder: 'F0kZNW3Jo4k',
        trainer: 'Zw6crM3NzD0',
      }
      this.videoId = list[this.dialog.play]
    } else {
      this.videoId = this.dialog.videoid ? this.dialog.videoid : '2F0oPG1PGQA'
    }
  },
}
</script>

<style lang="scss" scoped>
.yt-video {
  top: 0;
  left: 0;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto;
  z-index: 0;
  &_container {
    position: relative;
    margin: auto;
    background: black;
    min-width: 780px;
    max-width: 960px;
    height: 540px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

@media (min-width: 3440px) {
  .yt-video {
    &_container {
      min-width: 1920px;
      max-width: 1920px;
      height: 1080px;
    }
  }
}

@media (max-width: 768px) {
  .yt-video {
    height: var(--vh-3);
    &_container {
      margin: auto;
      height: var(--vh-3);
      height: calc(var(--vh-100) * 0.5625);
      width: 100vw;
      min-width: 0;
    }
  }
}
</style>
